import { Route, Switch, useRouteMatch } from 'react-router-dom';
import LearningManagerLayout from './components/LearningManagerLayout';
import CoursesAssignments from './pages/CourseAssignments';
import { getLMSRoutes } from './pages/LMS.constants';
import CreateAssignment from './pages/CreateAssignment';

const LearningManager: React.FC = () => {
	const lmsRoutes = getLMSRoutes();
	const { path } = useRouteMatch();

	return (
		<LearningManagerLayout>
			<Switch>
				<Route exact path={path} component={CoursesAssignments} />
				<Route
					exact
					path={`${path}${lmsRoutes.course}`}
					component={CoursesAssignments}
				/>
				<Route
					exact
					path={`${path}${lmsRoutes.createAssignment}`}
					component={CreateAssignment}
				/>
			</Switch>
		</LearningManagerLayout>
	);
};

export default LearningManager;
